import React from 'react';
import ActionButton from '~components/atoms/ActionButton';

import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import { TransactionStatusEnum } from '~utils/enums';
import UtilFunctions from '~utils/functions';
import * as Styles from './_confirmUpdateCollateralStatusModal.module.scss';
import { TDeleteCustomerCollateralReduxParams } from '~types/feat/customer';

const ConfirmDeleteCollateralModal = () => {
    const isOpen = useAppSelector(state => state.customer.modals.deleteCustomerCollateralModalIsOpen);
    const tempCollateralState = useAppSelector(state => state.customer.tempCollateralState);
    const isLoading = useAppSelector(state => state.approval.loadings.updateCollateralStatus);
    const error = useAppSelector(state => state.approval.errors.updateCollateralStatus);

    const dispatch = useAppDispatch();

    const setIsOpen = (open: boolean) => dispatch(combinedActions.customerSetCustomerCollateralModalIsOpen(open));
    const confirmDeleteCollateral = (params: TDeleteCustomerCollateralReduxParams) => dispatch(combinedActions.customerDeleteCustomerCollateralAttempt(params));

    const handleSubmitClick = () => {
        confirmDeleteCollateral(tempCollateralState);
    };

    const confirmButtonStyles = UtilFunctions.Styles.concatClassNames([
        (TransactionStatusEnum[TransactionStatusEnum.Cancelled] === 'Cancelled' ? Styles['confirm-reject'] : ''),
    ]);

    const handleOnModalClose = () => {
        if (error) {
            dispatch(combinedActions.approvalResetUpdateCollateralStatusState());
        }

        setIsOpen(false);
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleOnModalClose}
            title={`Confirm Cancel Collateral?`}
        >
            <div className={Styles['button-container']}>
                <ActionButton
                    label='Cancel'
                    onClick={handleOnModalClose}
                    className={Styles['cancel-button']}
                />

                <ActionButton
                    label='Confirm'
                    onClick={handleSubmitClick}
                    isLoading={isLoading}
                    className={confirmButtonStyles}
                />
            </div>

            {error
                && (
                    <Text
                        label={error}
                        isError
                    />
                )
            }
        </Modal>
    );
};

export default ConfirmDeleteCollateralModal;
